var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',[_c('md-card-content',[_c('div',{staticClass:"pro-tip"},[_c('ri',{attrs:{"n":"lightbulb-flash-line"}}),_c('div',[_vm._t("default")],2)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }